import React from "react";

const RouteHeader = props => {

    return (
        <div className="route-header">
        <div className="route-header__title">{props.title}</div>

        {!props.data ? "" :
            <table>
                <tbody>
                    {Object.keys(props.data).map(key =>
                        <tr className="route-header__info">
                            <td>{key}</td>
                            <td>{
                                props.data[key] instanceof Array ?
                                props.data[key].join(', ') :
                                props.data[key]
                                }</td>
                        </tr>
                    )}
                </tbody>
            </table>
        }
    </div>
    )
}

export default RouteHeader;